<template>
  <div id="applicant-edit-tab-internal-history">
    <ActionPage
      :show-company-contact="true"
      view-only
      is-history
      type="COMPANY"
      :resource-id="$route.params.id"
    />
  </div>
</template>

<script>
import ActionPage from "../../action/Page";

export default {
  components: {
    ActionPage
  }
};
</script>
